var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container",attrs:{"data-aos":"fade-up"}},[_c('div',{staticClass:"section-title"})])])}]

export { render, staticRenderFns }